<template>
  <div>
    <div class="environmental_bg">
      <div class="environmental_content">
        <h2>企业专访</h2>
        <div class="environmental_body">
          <img src="../../assets/images/icons_66.png" alt="" />
          <div class="environmental_line"></div>
          <div class="environmental_desc">
            <p>ENTERPRISE</p>
            <p>INTERVIEW</p>
          </div>
        </div>
      </div>
    </div>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="w80">
      <div class="fsb mb-60">
        <div style="width: 100%">
          <div class="">
            <div class="college_top">
              <div v-if="!vid" class="college_vider" @click="onClick">
                <img class="top_img" :src="lessonDetail.cover" alt="" />
                <img class="model" src="@/assets/images/play.png" />
              </div>
              <aliplayer
                class="college_aliplayer"
                v-else
                :playauth="playauth"
                :vid="vid"
                ref="aliplayer"
              ></aliplayer>
            </div>
            <div :class="[isBuy == true ?'college_middle mt-60':'college_middle']">
              <h4>{{ lessonDetail.title }}</h4>
              <p>
                <span>{{ lessonDetail.des }}</span>
              </p>
            </div>
          </div>
          <div class="mt-30">
          </div>
        </div>
      </div>
    </div>
    <!--弹框登录-->
    <loginDialog :dialogVisible.sync="dialogVisible"></loginDialog>
  </div>
</template>
<script>
import {
  getLessonDetailById,
  getLessonList,
  getExpertList,
  getCollegeFile,
  getInterviewDetailById, // 企业专访详情
} from "@/api/information";
import {
  addCollection,
  createorder,
  download,
  getorderstatus,
  vod,
  interviewVod,   // 专访视频播放
  alreadypurchase,
  iscollection,
  cancelcollection,
  getcurrentprice
} from "@/api/coment";
import { getUUID } from "@/utils/index";
import { smslogin, SmsCaptcha } from "@/api/user";
import contTitle from "../../common/contTitle";
import comentTitle from "../../common/comentTitle";
import swiperItem from "../../common/swiperItem";
import { getToken } from "@/utils/auth";
import userOperation from "../../common/userOperation";
import aliplayer from "../../components/aliplayer_interview";
import loginDialog from "../../components/loginDialog";
import breadCrum from "@/common/breadCrum";
import pdfLoader from "@/common/pdfLoader";
export default {
  inject: ["reload"],
  components: {
    contTitle,
    comentTitle,
    swiperItem,
    userOperation,
    aliplayer,
    breadCrum,
    pdfLoader,
    loginDialog,
  },
  data() {
    return {
      headTitle: "环学院",
      furl: "",
      isShow: true,
      headText: "",
      contTitle: "课程详情",
      contTitle1: "推荐视频",
      comentTitle: "环保达人",
      comentText: "更多 >",
      sourcetype: null,
      player: null,
      obj: {
        title: "",
        contCount: "",
        isShow: false,
        bannerUrl: require("@/assets/images/banner.jpg"),
      },
      lessonDetail: {},
      cate: "",
      coursePager: {
        curPage: 1,
        limit: 3,
      },
      curseList: [],
      active: true,
      id: "",
      expertList: [],
      expertQuery:{
        curPage:1,
        limit:9
      },
      total:0,
      status: false,
      isBuy: false,
      cate: "",
      orderNo: "", //订单编号
      playauth: "", //视频播放凭证
      vid: "",
      source: "",
      duration: " ", //播放时间
      dialogVisible: false,
      breadCrumList: [{ name: "企业专访", url: "/" }],
      fileShow: false,
      readFile: "",
      isYur: true,
      userid:''

    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getLessonDetail();
    this.getLessonList();
    this.getExpertList();
    this.getCaptcha();
    this.getCollegeFile();
   
  
    if (getToken() != undefined) {
      this.getAlreadypurchase();
      this.getIscollection();
      this.userid = this.$store.state.user.userInfo.data.userId;
    } else {
      // this.buy = true;
      this.isBuy = false;
    }
  },
  mounted() {
    if (getToken() != undefined) {
      this.getVod();
    }
  },
  watch: {
    $route(val) {
      this.id = val.query.id;
      this.getLessonDetail();
    },
    sourcetype(val, oldval) {
      if (1 == val) {
        this.$router.push({
          path: "/curriculumDetail",
          query: { id: this.id },
        });
      }
    },
  },
  methods: {
    showFile() {
      if (!this.readFile) {
        this.$message({
          message: "没有可以预览的文件！",
          type: "info",
          duration: 1000,
        });
        return;
      }
      this.fileShow = !this.fileShow;
    },
    //获取试读文件
    getCollegeFile() {
      getCollegeFile({ id: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.readFile = res.data;
        }
      });
    },
    toMore() {
      this.$router.push({
        path: "/expert_list",
      });
    },
    getstarttime(str) {
      if (null != str && undefined != str && str.length > 10) {
        return str.substring(0, 10);
      }
      return "";
    },
    onClick() {
      // if (
      //   null == this.vid ||
      //   null == this.playauth ||
      //   this.vid.length < 3 ||
      //   this.playauth.length < 3
      // ) {
      //   if (getToken() != undefined) {
      //      this.$confirm('确认要购买吗?','提示',{
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning'
      //      }).then(()=>{
      //        this.toBuy();
      //      }).catch(()=>{
      //         this.$message({
      //         type: 'info',
      //         message: '已取消购买'
      //        }); 
      //      })
      //   } else {
      //     this.dialogVisible = !this.dialogVisible;
      //     localStorage.setItem("rediretUrl", location.href);
      //   }
      // }
      this.getVod()
    },

    //获取视频播放认证
    getVod() {
      interviewVod({
        id: this.id,
      })
        .then((res) => {
          if (res.code == 0) {
            console.log("获取视频信息")
            console.log(res)
            this.playauth = res.data.playAuth;
            this.vid = res.data.videoMeta.videoId;
            this.source = res.data.videoMeta.title;
            this.duration = res.data.videoMeta.duration;
          }
        })
        .catch((err) => {});
    },
    //获取专访详情
    getLessonDetail() {
      getInterviewDetailById({ id: this.id }).then((res) => {
        console.log("专访详情")
        console.log(res)
        if (res.code == 0) {
          this.lessonDetail = res.data;
          // if (this.lessonDetail.integral){
          //   this.lessonDetail.integral = "/"+this.lessonDetail.integral+"积分"
          // }
          this.getMate(res.data);
          // this.cate = this.getCate(this.lessonDetail.category);
          this.headText = this.lessonDetail.title;
          // this.cate =
          //   this.lessonDetail.category && this.getCate(this.lessonDetail.category);
          this.sourcetype = res.data.sourcetype;
          this.breadCrumList.push({ name: this.lessonDetail.title });
        }
        if(getToken() != undefined){
          this.getprice(this.userid)
        }
      });
    },
    getCate(id) {
      return this.$store.getters.itemIndutry(id);
    },
    toCourseDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/environmental_college_detail",
        query: { id: item.id },
      });
      location.replace(routeUrl.href);
    },

    goBuy(patterns) {
      if (getToken() == undefined) {
        this.dialogVisible = !this.dialogVisible;
      } else {
        if(this.lessonDetail.price >0){
          this.$confirm('确认要购买吗?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            this.toBuy(patterns);
          }).catch(()=>{
            this.$message({
              type: 'info',
              message: '已取消购买'
            }); 
          })
        }else{
           this.toBuy(patterns);
        }   
      }
    },
    beforeClose() {
      this.dispatch = false;
    },
    //前往购买页面
    toBuy(patterns) {
      let postData = {
        amount: this.lessonDetail.price,
        goodsId: this.$route.query.id,
        goodsType: 4,
        buyPatterns: patterns
      };
      createorder(postData)
        .then((res) => {
          this.orderNo = res.data.orderNo;
          if (res.code == 0) {
            localStorage.setItem("list", JSON.stringify(res.data));
            localStorage.setItem("title", this.lessonDetail.title);
            localStorage.setItem("sourtype", res.sourtype);
            if (res.data.status == 1) {
              this.$message({
                message: "购买成功! 积分+1",
                type: "success",
              });
              this.isBuy = true;
              this.isYur = false;
              this.getVod();
            } else {
              let url = window.location.href;
              let str = url.split("/")[3];
              sessionStorage.setItem("url", str);
              this.$router.push({
                name: "payment_information",
              });
            }
          }
        })
        .catch((err) => {});
    },
    getCate(id) {
      return this.$store.getters.itemIndutry(id);
    },
    getLessonList() {
      getLessonList({
        ...this.coursePager,
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
           this.curseList = res.page.list;
        }
      });
    },
    goExpert(item){
      this.expertQuery.curPage = item;
      if(this.total == this.expertList.length) return;
      this.getExpertList();
    },
    //获取推荐专家
    getExpertList() {
      getExpertList({
        ...this.expertQuery,
        weight: 0,
      }).then((res) => {
        if(res.code == 0){
          this.total = res.data.totalCount;
          this.expertList = this.expertList.concat(res.data.list);
        }
      });
    },
    //课程收藏
    goCollection() {
      let params = {
        goodsId: this.id,
        goodsType: 4,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.id,
          goodstype:"4"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },
    //观看
    toView() {
      if (window.document.getElementsByClassName("outter")) {
        window.document.getElementsByClassName("outter")[0].click();
      }
    },
    //订单号查询购买状态
    getorderstatus() {
      let postData = {
        OrderNo: this.orderNo,
      };
      getorderstatus(postData)
        .then((res) => {
          if (re.code == 0) {
            if (res.data.status == 1) {
              this.show = true;
              this.getVod();
            }
          }
        })
        .catch((err) => {});
    },
    //查询资源是否已购买
    getAlreadypurchase() {
      let params = {
        goodstype: 4,
        goodsid: this.id,
      };
      alreadypurchase(params)
        .then((res) => {
          if (res.data == true) {
            this.isBuy = true;
            this.getVod();
          }
        })
        .catch((err) => {});
    },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.id,
        goodstype: 4,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },

    // handleClose() {
    //   this.dialogVisible = false;
    // },
    handleClick(tab, event) {},
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    onTout() {
      this.$router.replace("/");
    },  
    //根据会员权限，显示不同的价格
    getprice(id){
      let params = {
        userid:id,
        price:this.lessonDetail.price 
      };
     getcurrentprice(params).then((res)=>{
       if(res.code == 0){
           this.lessonDetail.price = res.data;
       }
     }).catch((err)=>{})
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keyword";
      metas[0].content = data.seokeywords;
      metas[1].name = "description";
      metas[1].content = data.seodescription;
      document.getElementsByTagName("title")[0].innerText =
        data.title + "_智污邦环保服务平台";
    },
  },
};
</script>
<style scoped lang="less">
.college_vider {
  height: 300px;
  position: relative;
}
.college_aliplayer {
   position: relative;
   width: 100%;
   height: 0;
   //margin-left: 22%;
  //  padding-bottom: 56%;
}
.environmental_bg {
  display: flex;
  align-items: center;
  width: 100%;
  height: 399px;
  background: url("../../assets/images/environmental_bg.jpg") no-repeat center/cover;
}
.environmental_content {
  margin: 0 0 0 10%;
  //width: 291px;
  width: 380px;
  @media (min-width: 1600px) {
    margin: 0 0 0 20%;
  }
  h2 {
    font-size: 95px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
  }
  .environmental_body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 75px;
      height: 55px;
      object-fit: cover;
    }
    .environmental_line {
      width: 1px;
      height: 56px;
      background: #ffffff;
    }
    .environmental_desc {
      p {
        &:nth-of-type(1) {
          font-size: 22px;
          font-family: Arial;
          font-weight: bold;
          color: #ffffff;
        }
        &:nth-of-type(2) {
          font-size: 41px;
          font-family: Arial;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }
}
.icon img {
  width: 20px;
  height: 19px;
  vertical-align: middle;
}
.f1 {
  flex: 1;
}
.fsb {
  display: flex;
  justify-content: space-between;
}

.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-50 {
  margin-left: 50px;
}
.mt-60{
  margin-top: 60px;
}
.mb-60 {
  margin-bottom: 60px;
}
.pl-10 {
  padding-left: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}

.top_img {
  width: 100%;
  height: 100%;
  position: relative;
}
.model {
  position: absolute;
  width: 50px;
  height: 50px;
  background: url("../../assets/images/play.png") no-repeat center/100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* margin-top: -25px; */
  z-index: 999;
}
.college_middle {
  width: 100%;
  // padding: 10px 0 28px;
  padding: 225px 0 28px;
  border-bottom: 1px solid #eeeeee;
}
.college_middle h4 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 5px;
  margin-left: 0%;
}
.college_middle p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  margin-top: 8px;
  margin-left: 0%;
}
.college_middle p.colors {
  color: #ffa65e;
  font-size: 21px;
  margin-left: 5px;
}
.college_bater {
  height: 41px;
  line-height: 41px;
  display: flex;
  justify-content: left;
  // background: #eeeeee;
  text-align: left;
}
.college_btn {
  width: 114px;
  height: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  font-size: 12px;
  margin-right: 20px;
  border-radius: 3px;
}
.background1 {
  background: #f6bc20;
}
.background2 {
  background: #ff7302;
}

.college_meter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
  padding-bottom: 43px;
  border-bottom: 1px solid #eeeeee;
}
.college_photo {
  width: 100%;
  height: 346px;
}
.college_shire {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.box_coment {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 46px;
}
.box_coment button {
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.shire_btn {
  margin-top: 50px;
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.college_recom {
  width: 32%;
  height: 210px;
}
.college_mater{
  position: relative;
  height: 162px;
}

.college_mater img {
  width: 100%;
  height: 100%;
}
.college_mater img:hover{
  cursor: pointer;
}
.college_mater img.model{
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}


.college_recom p {
  padding-top: 10px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-prev,
.button-next {
  width: 100%;
  line-height: 20px;
  text-align: center;
  background: linear-gradient(-79deg, #ff7602, #ffc602);
}
.swiper-container {
  height: 360px;
  border-right: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  padding: 0 10px;
}
.swiper-wrapper {
  height: 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.swiper-slide {
  height: 120px;
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.swiper-slide img {
  margin-left: 10px;
  width: 89px;
  height: 89px;
}
.export_desc {
  margin: 0px 10px;
}
.export_desc p:nth-child(1) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
}
.export_desc p:nth-child(2) {
  margin-top: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  /*多行溢出省略*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.college_top {
  width: 100%;
  height: 366px;
}

.model {
  position: absolute;
  width: 50px;
  height: 50px;
  background: url("../../assets/images/play.png") no-repeat center/100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.college_vider {
  // height: 366px;
  height: 575px;
  position: relative;
}
.college_age {
  display: flex;
  justify-content: left;
  margin-top: 15px;
}
.college_age p {
  margin-right: 50px;
  color: #333;
}
.college_wet {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/**弹框 */
/deep/.el-dialog {
  // height: 500px;
  width: 400px;
}
.dialog_midde {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.dialog_conent {
  width: 368px;
  // background:rgba(255, 255, 255, 0.8);
}
.moblie_bater {
  margin: 15px 30px;
}
/deep/ .el-tabs__nav-wrap::after {
  width: 0%;
}
/deep/ .el-tabs__item {
  font-size: 18px;
}
/deep/ .el-tabs__item.is-active {
  color: #333333;
  font-weight: bold;
}
/deep/ .el-tabs__item:hover {
  color: #333333;
}
/deep/ .el-tabs__active-bar {
  background-color: #333333;
}
.phone {
  position: relative;
}
.code {
  position: relative;
}
/deep/.phone .el-button {
  position: absolute;
  height: 49px;
  top: 0;
  right: 0;
  color: #ffffff;
  width: 95px;
  background: #fb7103;
  border: none;
  font-size: 12px;
}
/deep/.phone .el-button:hover {
  color: #ffffff;
}
.icon {
  width: 24px;
  height: 26px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 100;
}
.icons {
  width: 32px;
  height: 34px;
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: 100;
}
/deep/.el-input__inner {
  height: 50px;
}
/deep/.el-form-item__content {
  margin-left: 0px !important;
}
/deep/input.el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
}
/deep/.el-button {
  border: none;
}
/deep/.el-select .el-input__inner {
  color: #333333;
}
/deep/.el-input--suffix .el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}
/deep/.el-select .el-input__inner:focus {
  border-color: #eeeeee;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #eeeeee;
}
/deep/.el-form-item__content {
  margin-left: 0px !important;
}
/deep/.el-input__inner {
  height: 50px;
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}
.reset_login {
  width: 100%;
  height: 50px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.reset_login:hover {
  color: #ffffff;
}
.retrieve p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.shortCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
}
.retrieve p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.underline {
  padding-bottom: 5px;
  text-decoration: underline;
  cursor: pointer;
}
.other_fail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_icon {
  display: flex;
  justify-content: space-around;
  margin-top: 25px;
}
.other_icon img {
  width: 25px;
  height: 25px;
}
.moblie_logo {
  display: flex;
  justify-content: center;
  margin-top: -12px;
}
.moblie_logo img {
  width: 152px;
  height: 44px;
  cursor: pointer;
}
</style>
<style>
.el-message-box__btns .el-button {
  width: 80px;
}
.confirmButton {
  margin-left: -80px !important;
  margin-right: 105px !important;
}
.cancelButton {
  margin-right: -100px !important;
}
.cancelButton:hover {
  background-color: #fff;
  color: #333;
  border-color: #dcdfe6;
}
.college_aliplayer {
    position: relative;
    width: 100%;
    height: 575px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/college/enterprise_interview_detail.vue